// FlowBerry Pricing Configuration
// All prices are in USD

export const pricingConfig = {
  // Base prices for 25 stems by stem length (cm)
  sizePrices: {
    60: 45,
    70: 55,
    80: 65,
    90: 75,
  },
  
  // Available stem lengths
  stemLengths: [60, 70, 80, 90],
  
  // Quantity configuration
  quantity: {
    step: 25,
    min: 25,
    max: 200,
  },
  
  // Premium wrap add-on
  premiumWrap: {
    price: 20,
    label: 'Premium Wrap',
    description: 'Luxury gift wrapping with ribbon',
  },
  
  // Delivery options
  delivery: {
    minimum: 10,
    pickupLocation: 'Glendale',
    serviceArea: 'Los Angeles / LA County',
  },
  
  // Future: per-variety price adjustments
  // varietyMultipliers: {},
};

// Calculate bouquet price
export const calculatePrice = ({
  stemLength,
  quantity,
  premiumWrap,
  isDelivery,
}) => {
  const sizePrice = pricingConfig.sizePrices[stemLength] || 45;
  const basePrice = sizePrice * (quantity / 25);
  const wrapPrice = premiumWrap ? pricingConfig.premiumWrap.price : 0;
  const deliveryFee = isDelivery ? pricingConfig.delivery.minimum : 0;
  
  return {
    basePrice,
    wrapPrice,
    deliveryFee,
    total: basePrice + wrapPrice + deliveryFee,
  };
};

export default pricingConfig;
